export default __webpack_public_path__ + "static/media/m_b.570f2003.gif";